import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../../../manager'
import CreationToolSuperCutField from '../../../../../types/super-cut-field'
import CreationToolUserRestriction from '../../../../../types/user-restriction'
import { GridBlock } from '../../../../blocks'
import SegmentationTypeField from './fields/segmentation-type'
import SegmentationTimingField from './fields/segmentation-timing'
import CaptionPositionField from './fields/caption-position'
import CaptionStyleField from './fields/caption-style'

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoAdvanced = () => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)

    // filter out any fields that the user doesn't have access to.
    const fields = CreationToolSuperCutField.all('capture').filter(field => {
        const userRestriction = CreationToolSuperCutField.userRestriction(field)
        return CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
    })

    const fieldComponents = fields.map(field => {
        switch (field) {
            case CreationToolSuperCutField.SegmentationType:
                return SegmentationTypeField
            case CreationToolSuperCutField.SegmentaionTiming:
                return SegmentationTimingField
            case CreationToolSuperCutField.CaptionPosition:
                return CaptionPositionField
            case CreationToolSuperCutField.CaptionStyle:
                return CaptionStyleField
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={fields[i]} field={fields[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoAdvanced
